import { createReducer } from '../../helpers/reducers';

import { types } from '../../actions/tara';

const initialState = null;

const handleTaraSurveySuccess = (state, action) => action.payload.data;

const handlers = {
  [types.TARA_GET_SURVEY.SUCCESS]: handleTaraSurveySuccess,
};

const survey = createReducer(initialState, handlers);

export default survey;

export const getTaraSurvey = state => state.tara.survey;



// WEBPACK FOOTER //
// ./src/reducers/tara/survey.js